export default __webpack_public_path__ + "static/media/landing.8d474b9f.webm";